<div *ngIf="menusConfig" class="navigation-config-wrapper">
  <!-- Menu Visual Preview (Old tab bar style, illustration only) -->
  <div class="menu-preview-section mb-4">
    <div class="preview-title mb-2 text-muted font-small-3 text-uppercase fw-bold">
      <i class="bi bi-eye me-1"></i> {{ 'menu_preview' | translate }}
    </div>
    <div class="d-flex justify-content-center">
      <ul class="nav nav-tabs-preview">
        <li *ngFor="let navItem of menusConfig.navigations" class="nav-item">
          <a class="nav-link">
            <span class="nav-label">{{ navItem.label || ('ph_enter_label_link' | translate) }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- Sortable List of Links (Functional Section) -->
  <div cdkDropList (cdkDropListDropped)="drop($event)" class="link-items-list">
    <div *ngFor="let navItem of menusConfig.navigations; let navIndex = index" cdkDrag class="link-item-card"
      [class.expanded]="expandedIndex === navIndex">

      <!-- Link Item Header (Always visible) -->
      <div class="link-item-header">
        <div class="d-flex align-items-center flex-grow-1" (click)="toggleExpand(navIndex)">
          <!-- Drag Handle -->
          <div class="drag-handle me-3" cdkDragHandle>
            <i class="bi bi-grip-vertical"></i>
          </div>

          <!-- Label, Path and Status Badge -->
          <div class="link-info d-flex flex-column">
            <div class="d-flex align-items-center">
              <span class="link-label">{{ navItem.label || ('ph_enter_label_link' | translate) }}</span>
              <span class="badge bg-light-info ms-2 opacity-75 font-small-2">{{ getTargetLabel(navItem.target) }}</span>
            </div>
            <div *ngIf="getPathLabel(navItem)" class="link-path-info mt-1">
              <i class="bi bi-link-45deg me-1"></i>
              <span>{{ getPathLabel(navItem) }}</span>
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="link-actions d-flex align-items-center">
          <button type="button" class="btn btn-icon-sm btn-delete me-2" (click)="close($event, navIndex)"
            [title]="'ac_remove' | translate">
            <i class="bi bi-trash"></i>
          </button>
          <button type="button" class="btn btn-icon-sm btn-expand" (click)="toggleExpand(navIndex)"
            [class.rotated]="expandedIndex === navIndex">
            <i class="bi bi-chevron-down"></i>
          </button>
        </div>
      </div>

      <!-- Link Item Content (Config Form - visible when expanded) -->
      <div class="link-item-content" *ngIf="expandedIndex === navIndex">
        <div class="p-3 bg-white border-top">
          <app-dynamic-link-config [siteId]="siteId" [navItem]="navItem" [navIndex]="navIndex"
            [pagesListDll]="pagesListDll">
          </app-dynamic-link-config>
        </div>
      </div>

      <!-- Drag Preview Placeholder -->
      <div class="link-placeholder" *cdkDragPlaceholder></div>
    </div>
  </div>

  <!-- Add New Link Button -->
  <div class="mt-3 px-2">
    <button type="button" class="btn btn-add-link w-100" (click)="add($event)">
      <i class="bi bi-plus-lg me-2"></i>
      {{ 'menu_add_link' | translate }}
    </button>
  </div>
</div>